var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isAdminRoute)?_c('NavBar'):_vm._e(),_c('router-view'),(!_vm.isAdminRoute)?_c('FooterBar'):_vm._e(),(!_vm.isAdminRoute)?_c('el-backtop',{attrs:{"right":40,"bottom":40}},[_c('div',{staticClass:"back-top-btn"},[_c('i',{staticClass:"el-icon-arrow-up"})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }